import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** Existing direct-value token identity; not an executable formatter language. */
export const OTTOPILOT_DIRECT_VALUE_TEMPLATE_OPERATION_ID = "fcb46858-4d6e-4afe-bc11-3cd88c580335";

const unresolvedOttopilotDirectValueTemplateRegex = new RegExp(`👉${OTTOPILOT_DIRECT_VALUE_TEMPLATE_OPERATION_ID}👆.*?👈`, "gu");

/** Resolves direct-value tokens; missing values are empty and other operations stay literal. */
export function processOttopilotStringTemplate(templateString: string, templateVars: Readonly<Record<Uuid, unknown>>): string {
    for (const [key, value] of Object.entries(templateVars)) {
        const stringValue = valueToText(value);
        templateString = templateString.replaceAll(`👉${OTTOPILOT_DIRECT_VALUE_TEMPLATE_OPERATION_ID}👆${key}👈`, stringValue);
    }
    return templateString.replace(unresolvedOttopilotDirectValueTemplateRegex, "");
}

export function valueToText(value: unknown): string {
    if (value === null || value === undefined) {
        return "";
    }
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint" || typeof value === "symbol") {
        return String(value);
    }
    if (typeof value === "function") {
        return value.toString();
    }

    return "";
}
